import { FormField, FormFieldProps } from './field'

import { TextInput } from '@elements/text-input'
import { TextInputProps } from 'types/ui'

export type TextFieldProps = Omit<FormFieldProps<TextInputProps>, 'component'>

export function TextField(props: TextFieldProps) {
  return <FormField {...props} component={TextInput} />
}
